module.exports = __webpack_public_path__ + "img/orkney-islands.dd9f8078.png";